import apinode from '../../apinode'

class OrderFileService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll(pedido) {
    const response = await apinode.get(`/order-files/${pedido}/${this.idconta}`)

    return response.data
  }

  async create(attachments) {
    const formData = new FormData()

    for (const attachment of attachments) {
      formData.append('file', attachment.file)
      formData.append('descricao', attachment.descricao)
      formData.append('pedido', attachment.pedido)
    }

    await apinode.post(`/order-files/${this.idconta}`, formData)
  }

  async delete(id) {
    await apinode.delete(`/order-files/${id}/${this.idconta}`)
  }
}

export default new OrderFileService()
